
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/xandr",
      function () {
        return require("private-next-pages/destinations/xandr.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/xandr"])
      });
    }
  